<template>
    <div id="app">
        <v-app v-if="!helpers.isMobile() || isAdmin">
            <Header />
            <div class="page-layout">
                <div class="columns">
                    <div class="column is-offset-1 is-10">
                        <v-content>
                            <v-container fluid>
                                <vue-page-transition name="fade-in-left">
                                    <router-view />
                                </vue-page-transition>
                            </v-container>
                        </v-content>
                    </div>
                </div>
            </div>
            <Footer />
            <NoCreditCardNotification group="no-credit-card"></NoCreditCardNotification>
        </v-app>
        <v-app v-if="helpers.isMobile() && !isAdmin">
            <v-content fluid>
                <vue-page-transition name="fade-in-left">
                    <router-view />
                </vue-page-transition>
            </v-content>

            <v-bottom-navigation v-model="bottomNav" grow app v-if="isLoggedIn">
                <v-btn value="offers" to="/panel/offers">
                    <span>{{ $t("my_offers") }}</span>
                    <v-icon>mdi-credit-card</v-icon>
                </v-btn>

                <v-btn value="applications" to="/panel/my_applications">
                    <span>{{ $t("my_applications") }}</span>
                    <v-icon>mdi-currency-usd</v-icon>
                </v-btn>

                <v-btn value="profile" to="/panel/profile">
                    <span>{{ $t("profile") }}</span>
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </v-bottom-navigation>
            <MobileToast group="main"></MobileToast>
            <NoCreditCardNotificationMobile group="no-credit-card"></NoCreditCardNotificationMobile>
        </v-app>
    </div>
</template>

<script>
import { Header, Footer } from "./shared/components";
import * as Helpers from "@/app/shared/services/helpers";
import MobileToast from "@/app/mobile/ui/notifications/MobileToast";
import NoCreditCardNotification from "@/app/client/ui/notifications/NoCreditCardNotification";
import NoCreditCardNotificationMobile from "@/app/mobile/ui/notifications/NoCreditCardNotification";

export default {
    name: "App",
    components: {
        Header,
        Footer,
        MobileToast,
        NoCreditCardNotification,
        NoCreditCardNotificationMobile,
    },
    data() {
        return {
            bottomNav: "offers",
            helpers: Helpers,
        };
    },
    created() {
        this.$store.dispatch("GET_APP_SETTINGS").then(() => {
            if (localStorage.getItem("testGroup"))
                this.$store.dispatch("GET_GROUP_APP_SETTINGS", localStorage.getItem("testGroup"));
        });
        localStorage.setItem("pxlid", new URLSearchParams(window.location.search).get('pxlid'));
        localStorage.setItem("vkid", new URLSearchParams(window.location.search).get('vkid'));
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.IS_LOGGED_IN;
        },
        isAdmin() {
            return this.$store.getters.IS_ADMIN;
        },
    },
};
</script>

<style>
body {
    font-family: "Fira Sans Condensed", "Roboto", Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fbfbfb;
    overflow: hidden;
}

.page-layout {
    margin: 10px 50px 50px;
}

@media (max-width: 960px) {
    .page-layout {
        margin: 0px 10px 10px;
    }
}

.text-center {
    text-align: center;
}

.color-white {
    color: white;
}
</style>
